// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2wNmz","modalFooterButton":"ModalNotes_modalFooterButton__1WbBb"};